/* SBO v3 newsletter popup: when to open, and remembering the answer.
   Markup and the reasons behind it are in sections/sbo-v3-newsletter-popup.liquid.
   The form submits natively, so Shopify's storefront CAPTCHA handles it
   untouched; this file never intercepts the submit. */
(function () {
  const dialog = document.querySelector('[data-sbo3-newsletter]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  /* One key per browser. 'dismissed' or 'subscribed': either way the popup
     stays closed from then on. Storage can be blocked (private mode), in
     which case the popup simply behaves as if it had never been seen. */
  const STORE_KEY = 'sbo3-newsletter';
  const recall = () => { try { return localStorage.getItem(STORE_KEY); } catch (e) { return null; } };
  const remember = value => { try { localStorage.setItem(STORE_KEY, value); } catch (e) {} };

  const form = dialog.querySelector('form');
  const designMode = dialog.hasAttribute('data-design-mode');
  const succeeded = Boolean(dialog.querySelector('[data-sbo3-nl-success]'));

  /* The stylesheet is only fetched when the popup is about to open, so a
     visitor who never sees it never downloads it. The dialog is display:none
     until opened, so it needs no styles before then. */
  let stylesheet;
  function loadStyles() {
    if (!stylesheet) {
      stylesheet = new Promise(resolve => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = dialog.dataset.stylesheet;
        link.onload = link.onerror = resolve;
        document.head.appendChild(link);
      });
    }
    return stylesheet;
  }

  function open() {
    if (dialog.open) return;
    loadStyles().then(() => { if (!dialog.open) dialog.showModal(); });
  }

  dialog.addEventListener('click', event => {
    /* A click on the dialog element itself, not its content, is a click on
       the backdrop. */
    if (event.target === dialog || event.target.closest('[data-sbo3-nl-close]')) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (!designMode) remember(succeeded ? 'subscribed' : 'dismissed');
  });

  const copyButton = dialog.querySelector('[data-sbo3-nl-copy]');
  if (copyButton) {
    copyButton.addEventListener('click', () => {
      const code = dialog.querySelector('[data-sbo3-nl-code]').textContent.trim();
      const status = dialog.querySelector('[data-sbo3-nl-copied]');
      const announce = message => { if (status) status.textContent = message; };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(() => announce('Code copied.'), () => announce('Copy the code above.'));
      } else {
        announce('Copy the code above.');
      }
    });
  }

  if (designMode) {
    document.addEventListener('shopify:section:select', event => { if (event.target.contains(dialog)) open(); });
    document.addEventListener('shopify:section:deselect', event => { if (event.target.contains(dialog)) dialog.close(); });
    return;
  }

  /* Back from a customer-form POST. Liquid cannot tell which form posted:
     form.posted_successfully? and form.errors are true for every customer
     form on the page, so after a footer signup this popup also renders its
     success panel (or the footer's errors). Shopify appends the posting
     form's id as the URL hash, and that is how the two are told apart here.
     - Our POST: open straight away, onto the success or error state.
     - The footer's POST: never open. If it succeeded, the visitor has
       subscribed, so the popup should not ask them again. */
  if (dialog.querySelector('[data-sbo3-nl-open-now]')) {
    const postedFromPopup = !location.hash || location.hash === '#' + (form && form.id);
    if (succeeded) remember('subscribed');
    if (postedFromPopup) open();
    return;
  }

  if (recall()) return;

  /* Both values come from range settings in the section schema, which
     already bounds them. */
  const delay = Number(dialog.dataset.delay) * 1000;
  const depth = Number(dialog.dataset.scroll) / 100;
  let timer;

  function trigger() {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    open();
  }
  function onScroll() {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= depth) trigger();
  }

  /* The delay counts from the visitor's first interaction, not from page
     load. A popup on a bare timer lands in the middle of the load for anyone
     who has not touched the page yet: in the 2026-09-23 DEV run, Lighthouse
     caught it appearing 8s after load and counted that as the page still
     rendering, which put mobile Speed Index at 14.4s. A visitor who leaves
     without interacting never sees the popup, which is also the visitor it
     would only annoy. The scroll depth trigger works as before, and
     scrolling is itself an interaction. */
  const FIRST_INTERACTION = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'];
  function startDelay() {
    FIRST_INTERACTION.forEach(type => window.removeEventListener(type, startDelay));
    if (!timer) timer = setTimeout(trigger, delay);
  }
  function listen() {
    FIRST_INTERACTION.forEach(type => window.addEventListener(type, startDelay, { passive: true }));
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  if (document.readyState === 'complete') listen();
  else window.addEventListener('load', listen, { once: true });
})();
